import React from "react";
import { ConfigurationWell } from "components/configurationforms";
import SectionGrid from "components/common/Section/SectionGrid";
import ForwarderInputThroughput from "../../metrics/ForwarderInputThroughput";
const ExpandedConfigurationSection = ({ input, inputDescriptions }) => {
  const inputDescription = inputDescriptions == null ? void 0 : inputDescriptions[input.type];
  return /* @__PURE__ */ React.createElement(SectionGrid, null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, input.title, " \xA0 (", input.input_id, ")"), /* @__PURE__ */ React.createElement(ConfigurationWell, { id: input.input_id, configuration: input.configuration, typeDefinition: inputDescription })), input.forwarder_id && /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("span", null, "Throughput / Metrics"), /* @__PURE__ */ React.createElement("br", null), /* @__PURE__ */ React.createElement(
    ForwarderInputThroughput,
    {
      forwarder: { id: input.forwarder_id },
      input: { ...input, id: input.input_id }
    }
  )));
};
export default ExpandedConfigurationSection;
